import { render, staticRenderFns } from "./descriptionSpecialtyProgram.vue?vue&type=template&id=427586a0&scoped=true&"
import script from "./descriptionSpecialtyProgram.vue?vue&type=script&lang=js&"
export * from "./descriptionSpecialtyProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427586a0",
  null
  
)

export default component.exports